export default "__VITE_ASSET__DeFp$62h__"